import React from "react";
import { filter } from "lodash";

import Tableau from "../../containers/Tableau";

import Compo from "../Compo";

import Accordion from "react-bootstrap/Accordion";

const RisqueMenu = ({
	refIndic,
	currentCompo,
	clickCompo,
	territoire,
	niveau = 5,
	composition = null,
	bsCol,
	currentIndic
}) => {
	const refIndicRisque = filter(
		refIndic,
		(compo) =>
			compo.niveau === niveau &&
			(composition === null || composition.includes(compo.id)) &&
			compo.id !== "I"
	);

	return (
		<nav className="indicators-menu">
			{refIndicRisque.map((compo) => {
				return (
					<div key={compo.id} className={bsCol[compo.id]}>
						<div>
							{compo.id === "VS" && (
								<span style={{ color: "white" }}>
									{compo.description.toUpperCase()}
								</span>
							)}
							{compo.id !== "VS" && (
								<Accordion activeKey={currentCompo}>
									<Accordion.Item
										eventKey={compo.id}
										style={{
											border: "none",
											backgroundColor: "transparent",
										}}>
										<Accordion.Header
											onClick={() => {
												clickCompo(compo.id);
											}}>
											<span>{compo.description.toUpperCase()}</span>
										</Accordion.Header>
										<Accordion.Body style={{ padding: 0 }}>
											{!currentCompo || (compo.id === currentCompo && <Tableau />)}
										</Accordion.Body>
									</Accordion.Item>
								</Accordion>
							)}
							{niveau > 3 && (
								<Compo
									refIndic={refIndic}
									currentCompo={currentCompo}
									currentIndic={currentIndic}
									clickCompo={clickCompo}
									territoire={territoire}
									niveau={niveau - 1}
									composition={compo.composition}
								/>
							)}
						</div>
					</div>
				);
			})}
		</nav>
	);
};

export default RisqueMenu;
